export default __webpack_public_path__ + "static/media/ap.7f679e3d.png";